import React, { PureComponent } from 'react'
import { DatePicker } from 'antd-mobile';
import timeIcon from '../../assets/img/time.png';
import moment, { Moment } from 'moment';
import arrive from '../../assets/img/arrive.png';
import './time-picker.scss';
export interface ITimePickerState {
  timePickerVisible: boolean;
  startTimeText: string;
  endTimeText: string;
  startTime: Date;
  endTime: Date;
}

export default class TimePicker extends PureComponent<any, ITimePickerState> {

  openType: 'startTime' | 'endTime' = 'startTime';

  constructor(props: any) {
    super(props);
    this.state = {
      timePickerVisible: false,
      startTimeText: '',
      endTimeText: '',
      startTime: new Date(),
      endTime: new Date()
    };
  }

  componentDidMount() {
    if (this.props.startTime) {
      this.setTime().startTime(this.props.startTime);
    }
    if (this.props.endTime) {
      this.setTime().endTime(this.props.endTime);
    }
  }

  setTime() {
    return {
      endTime: (v: any | Moment) => {
        v = moment(v).endOf('month').format('YYYY/MM/DD HH:mm:ss')
        this.setState({
          endTime: moment(v).toDate(),
          endTimeText: moment(v).format('YYYY/MM'),
        });
      },
      startTime: (v: any | Moment) => {
        v = moment(v).startOf('month').format('YYYY/MM/DD HH:mm:ss')
        this.setState({
          startTime: moment(v).toDate(),
          startTimeText: moment(v).format('YYYY/MM')
        });
      }
    };
  }

  showDatePicker(type: 'startTime' | 'endTime') {
    this.openType = type;
    this.setState({
      timePickerVisible: true
    });
  }

  close = () => {
    this.setState({
      timePickerVisible: false
    });
  }

  timeValueChange(v: any) {
    if (this.openType === 'startTime') {
      v = moment(v).startOf('month').format('YYYY/MM/DD HH:mm:ss')
      this.setState({
        startTimeText: moment(v).format('YYYY/MM'),
        startTime: v
      });
    } else {
      v = moment(v).endOf('month').format('YYYY/MM/DD HH:mm:ss')
      this.setState({
        endTimeText: moment(v).format('YYYY/MM'),
        endTime: v
      });
    }
  }

  callback = () => {
    if (this.props.onSearch) {
      this.props.onSearch(this.state);
    }
  }

  render() {
    return (
      <div className="timePicker">
        <div className="content">
          <div className="timeShow" onClick={this.showDatePicker.bind(this, 'startTime')}>
            <img src={timeIcon} alt="" className="timeIcon"></img>
            <label className="timeLable">开始时间</label>
            <label className="timeValue">{this.state.startTimeText || "选择时间"}</label>
            <img src={arrive} alt="" className="downArrive"></img>
          </div>
          <div className="timeShow" onClick={this.showDatePicker.bind(this, 'endTime')}>
            <img src={timeIcon} alt="" className="timeIcon"></img>
            <label className="timeLable">结束时间</label>
            <label className="timeValue">{this.state.endTimeText || "选择时间"}</label>
            <img src={arrive} alt="" className="downArrive"></img>
          </div>
          <div className="flex flexCenter">
            <button className="inquiryButton" onClick={this.callback}>查询时间</button>
          </div>
        </div>
        <DatePicker
          visible={this.state.timePickerVisible}
          onOk={this.close}
          title={this.openType === 'startTime'? '开始时间': '结束时间'}
          mode="month"
          onDismiss={() => this.close()}
          onChange={(v: Date) => this.timeValueChange(v)}></DatePicker>
      </div>
    )
  }
}
